import { v4 as uuid } from 'uuid'

/**
 * An abstract base class for a component.
 */
class BaseComponent {
    /**
     * A constructor that sets up internal `element` and `componentid` attributes.
     *
     * Subclasses should avoid overriding this and use `init()` as an entrypoint instead.
     *
     * @param {Element} element - The base HTML element representing the component's markup.
     */
    constructor(element) {
        this.element = element
        this.componentid = uuid()
        this.element.setAttribute('data-componentid', this.componentid)
        if (!Object.hasOwn(window.sir, 'components')) {
            window.sir.components = {}
        }
        window.sir.components[this.componentid] = this
    }

    /**
     * Factory method for creating instances of a component.
     * @param {string} selector - A selector used with `querySelectorAll`
     */
    static create(selector = 'body') {
        if (sir.isEditor) {
            if (!(selector in sir._componentClasses)) {
                sir._componentClasses[selector] = []
            }

            if (!sir._componentClasses[selector].includes(this)) {
                sir._componentClasses[selector].push(this)
            }
        }

        addEventListener('DOMContentLoaded', () => {
            this._create(selector)
        })
    }

    /**
     * Runs after object creation.
     * @param {BaseComponent[]} instances - All instances of the subclassed object
     */
    static onAfterCreate(instances) {} // eslint-disable-line no-unused-vars

    static _create(selector, root = document) {
        const all = []
        const elements = root.querySelectorAll(selector)
        elements.forEach(element => {
            if (element.dataset.componentInit !== 'true') {
                all.push(new this(element))
                element.dataset.componentInit = true
            }
        })
        this.onAfterCreate(all)
    }

    static _onBlockListUpdate(root) {
        for (const [selector, classes] of Object.entries(sir._componentClasses)) {
            classes.forEach(classConstructor => {
                classConstructor._create(selector, root)
            })
        }
    }
}

export default BaseComponent
